import { FC, Fragment, ReactNode } from 'react';

import {
  CommentProfileInfoSkeleton,
  ProfileInfo,
  ProfileInfoSkeleton,
} from '@/components/ui/shared/profile/ProfileInfo/ProfileInfo';
import { useResources } from '@/lib/datx-jsonapi-react';
import { queryLectureCommentProfiles } from '@/queries/thin-profiles';
import { Comment } from '@/resources/Comment';

export interface ICommentProfileProps {
  comment: Comment;
  postedAt: ReactNode;
}

export const CommentProfile: FC<ICommentProfileProps> = ({ comment, postedAt }) => {
  const { data: profiles } = useResources(queryLectureCommentProfiles(comment?.user?.id));
  const profile = profiles?.[0];

  if (!profile) {
    return <CommentProfileInfoSkeleton />;
  }

  return (
    <Fragment>
      <ProfileInfo
        flexBasis="max-content"
        key={profile.id}
        fullName={profile.fullName}
        fullNameSuffix={postedAt}
        avatarUrl={profile.mediumSquareAvatarUrl}
        title={profile.organizationalRole}
      />
    </Fragment>
  );
};
